import { axiosInstance as axios } from "services";

export const fetchPaymentHistoryDetail = async (companyId, params) => {
  const { data } = await axios.get(`/admin/subscription/company/${companyId}/payment-history-detail`, { params });
  if (!data.success) throw new Error(data.error?.message || "Failed to fetch payment history details");
  return data;
};
